<template>
<div class="edit">
    <!-- Sticky header met titel en knop -->
    <div class="sticky-header">
      <h1>berging types</h1>
      <div class="sticky-header-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>
    </div>

    <form class="default-form edit-form" @submit.prevent="">

      <div class="default-form-field">

        <div class="default-form-field-types">
          <div class="default-form-field-types-header default-form-field-types-edit-row">
            <span>Naam</span>
            <span></span>
          </div>

          <div v-for="(type, i) in types" :key="i" class="default-form-field-types-edit-row-order">
            <input type="text" class="default-form-field-input" :id="'input' + i" v-model.trim="type.name" @keydown.enter="add(i + 1)">

            <button class="default-form-field-button" @click="moveUp(i)">
              <mdicon name="chevron-up" class="default-form-field-button-icon" size="25" />
            </button>

            <button class="default-form-field-button" @click="moveDown(i)">
              <mdicon name="chevron-down" class="default-form-field-button-icon" size="25" />
            </button>

            <button class="default-form-field-button" @mousedown="remove(i)" >
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="add(types.length)">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>

    </form>
  </div>
</template>

<script>
  import isEqual from 'lodash.isequal'
  import { mapGetters } from 'vuex'
  import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

  export default {
    name: "ModelTypes",

    components: {
      LoadingButton
    },

    data () {
      return {
        types: [],
        formValid: false,
        loading: false,
      }
    },

    methods: {
      async get () {
        await this.$store.dispatch('getModelsInfo')
        this.types = JSON.parse(JSON.stringify(this.data))
      },

      async update () {
        this.loading = true

        this.types.forEach((type, i) => {
          //added +1 for the order because the order starts at 1, and order=0 gives an error with sorting
          type.order = i + 1
        });

        let remove = []
        let update = []
        let insert = []

        for (let i = 0; i < this.data.length; i++) {

          const keepId = this.types.find((t) => t.id === this.data[i].id)

          if (!keepId) {
            remove.push(this.data[i])
          } else {
            const nameChanged = this.types.find((t) => t.id === this.data[i].id && t.name !== this.data[i].name)
            const orderChanged = this.types.find((t) => t.id === this.data[i].id && t.order !== this.data[i].order)

            if (nameChanged) {
              update.push(nameChanged)
            }

            if (orderChanged) {
              update.push(orderChanged)
            }
          }
        }

        for (let i = 0; i < this.types.length; i++) {
          if (!this.types[i].id) {
            insert.push(this.types[i])
          }
        }

        try {
          // console.log(JSON.parse(JSON.stringify(update)), JSON.parse(JSON.stringify(this.data)))
          await this.$store.dispatch('updateBergingTypes', {
            remove: remove,
            update: update,
            insert: insert
          })
        } catch (err) {
          console.log(err)
          this.loading = false
        }

        this.loading = false
        this.types = JSON.parse(JSON.stringify(this.data))
      },
      
      add (i) {

        if (i === this.types.length) {
          // console.log(this.types)
          this.types.push({
            name: "",
            order: this.types.length,
            id: null,
          })
        }

        this.$nextTick(() => {
          document.getElementById('input' + (i)).focus()
        })
      },

      remove (i) {
        if(this.types[i].name.toLowerCase() === 'geen') return
        this.types.splice(i, 1)
      },

      moveUp(i) {
        if (i === 0) return
        this.types.splice(i - 1, 0, this.types.splice(i, 1)[0])
      },

      moveDown(i) {
        if (i === this.types.length - 1) return
        this.types.splice(i + 1, 0, this.types.splice(i, 1)[0])
      }
    },

    computed: {
      ...mapGetters({
        data: "getBergingTypes"
      }),
    },

    created () {
      this.get()
      // setTimeout(() => {
      //   console.log(this.data)
      // }, 1000)
    },

    watch: {
      types: {
        deep: true,
        immediate: false,
        handler () {
          if (isEqual(this.types, this.data)) {
            this.formValid = false
          } else {
            this.formValid = true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    min-width: min(100%, 800px);
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  h1 {
    margin: 0;
    text-align: left;
    flex: 1;
  }
  
  &-button {
    flex-shrink: 0;
    margin-left: 20px;
  }
}

</style>